import React from 'react';

const TestSubmissionConfirm = ({ onReview, onSubmit }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-8 text-center animate-fadeIn">
      <div className="bg-white dark:bg-card-dark p-8 rounded-3xl shadow-xl border border-slate-200 dark:border-slate-800 max-w-lg w-full">
        <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
          <span className="material-symbols-outlined text-4xl">check_circle</span>
        </div>
        
        <h2 className="text-2xl font-black text-slate-800 dark:text-white mb-2">
          You've reached the end!
        </h2>
        
        <p className="text-slate-500 dark:text-slate-400 mb-8">
          You have completed all questions in this personalized test. Would you like to submit your answers now?
        </p>
        
        <div className="flex flex-col gap-3">
          <button 
            onClick={onSubmit}
            className="w-full py-3.5 px-6 bg-primary-blue hover:bg-blue-600 text-white font-bold rounded-xl shadow-lg shadow-blue-200 dark:shadow-none transition-all flex items-center justify-center gap-2"
          >
            <span>Submit & View Results</span>
            <span className="material-symbols-outlined">arrow_forward</span>
          </button>
          
          <button 
            onClick={onReview}
            className="w-full py-3.5 px-6 bg-white border-2 border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 font-bold rounded-xl transition-all flex items-center justify-center gap-2 dark:bg-transparent dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800"
          >
            <span className="material-symbols-outlined">history</span>
            <span>Review Answers</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TestSubmissionConfirm;
